<template>
  <div class="content">
    畅由生活应用隐私政策<br />
    本版本发布日期：2022年8月25日<br />

    生效日期：2022年8月25日<br />

    畅由生活应用是上海分互链信息技术有限公司（注册地址：中国（上海）自由贸易试验区新金桥路1122号18层1812室，以下称“我们”）为您提供的一款数字积分等系列商业产品。<br />

    我们非常重视用户的隐私和个人信息安全保护，我们将按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。我们希望通过《隐私政策》（以下简称“本政策”）向您说明畅由生活客户端（以下简称“本客户端”）如何收集、使用、存储、共享和保护您的个人信息，以及您可以如何行使您的用户权利。<br />

    在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体标识的条款，确保您充分理解和同意后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。<br />

    本政策将帮助您了解以下内容：<br />

    一、我们如何收集和使用您的个人信息<br />

    二、我们如何使用Cookie和同类技术<br />

    三、我们如何共享、转让、公开披露您的个人信息<br />

    四、我们如何保护和保存您的个人信息<br />

    五、您的权利<br />

    六、关于儿童个人隐私政策的特别约定<br />

    七、本政策如何更新<br />

    八、如何联系我们<br />

    九、其他<br />

    一、我们如何收集和使用您的个人信息<br />
    个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。<br />

    （一）为保证您正常使用本客户端的产品或服务，我们需要收集、存储和使用下列与您有关的信息：包括但不限于：手机号码、账号信息、收货人信息、交易信息、支付信息。一些服务可能是畅由生活与合作伙伴共同提供，如果用户使用此类服务，则畅由生活和合作伙伴都会收到相关用户信息。<br />
    上述权限如果您拒绝提供，会影响对应功能的正常使用，但不影响本客户端其他功能的使用。<br />

    您使用本客户端服务期间我们会持续使用您授权使用的信息,在您停止使用客户端服务后，我们会停止使用。<br />

    我们在此特别提醒您：<br />

    1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，故基本/附加功能及对应收集使用的个人信息类型、范围等会有所区别，请以具体的产品/服务功能为准；<br />

    2、为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术，随之我们可能会不时推出新的或优化后的功能，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。如发生上述情形，我们将通过更新本政策、弹窗、页面提示等方式另行向您详细说明，并为您提供自主选择同意的方式，且在征得您明示同意后再开始收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过本政策文末联系方式与我们联系，我们会尽快为您作出解答。<br />

    我们会为您提供的各项具体功能场景包括:<br />

    （一）帮助您成为我们的会员及账户管理<br />
    1、基础会员服务<br />
    我们基于畅由生活平台账户为您提供服务。为了创建畅由生活平台账户您需要至少向我们提供您的手机号码、拟使用的会员名和密码。如果您拒绝提供上述信息，您将无法注册畅由生活平台账户，仅可以使用浏览、搜索服务。<br />

    我们会根据您的畅由生活平台账户使用情况及平台设置的账户等级计算规则确定您当前的等级，并为您提供相应账户等级所对应的基本权益。<br />

    2、附加会员服务<br />
    特别会员权益：如果您选择提供真实姓名、性别、出生日期、居住地、昵称、头像等非注册必须的个人资料，我们可以为您提供会员生日特权等更加个性化的会员服务。其中，如果您提供昵称和头像的，您的昵称、头像将公开显示。<br />

    实名认证：您可以根据认证要求提供相应的身份信息（身份证、护照、户口簿及其他身份证件信息）以完成实名认证。<br />

    授权登录：我们可能经您同意后向第三方共享您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或第三方处直接登录。我们将在您授权同意的范围内使用您的相关信息。<br />

    （二）向您展示商品或服务信息<br />
    为向您展示更契合您需求的商品或服务信息，我们会收集和使用您在访问或使用畅由生活平台网站或客户端时的浏览、搜索记录及设备信息、服务日志信息，提取您的偏好特征，并向您推送您可能感兴趣的商业广告及其他信息。其中：<br />

    设备信息：我们会根据您在访问及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、MAC地址及IMEI、IDFA、OAID等设备标识符、设备环境、移动应用列表等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）、运行中的进程信息。<br />

    服务日志信息：当您访问或使用畅由生活平台网站或客户端提供的产品或服务时，我们会自动收集和记录您的详细使用情况，作为服务日志保存，包括浏览记录、点击查看记录、搜索查询记录、收藏、添加至购物车、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。<br />

    请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。<br />

    （三）为您提供收藏、加购、关注与分享功能<br />
    在您浏览我们网站或客户端的过程中，您可以选择对感兴趣的商品及/或服务进行收藏、添加至购物车、与您感兴趣的商家/品牌/其他会员建立关注关系、通过我们提供的功能组件向第三方分享商品/服务信息。在您使用上述功能的过程中，我们会收集包括您的收藏及添加购物车的记录、关注关系、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。<br />

    您可以在收藏夹、购物车管理或删除您的收藏和加购信息。<br />

    （四）帮助您完成下单及订单管理<br />
    当您在我们的产品及/或服务中订购具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,您需至少提供您的收货人姓名、收货地址、收货人联系电话，对于部分特殊类型的商品和服务您还需要提供该商品或服务所必需的其他信息，例如涉及跨境交易时您需要提供您的身份证号以完成清关。<br />

    同时该订单中会载明您所购买的商品及/或服务信息、具体订单号、订单创建时间、您应支付的金额、您的备注信息。我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、便于您查询订单信息、提供客服与售后服务及其他我们明确告知的目的。<br />

    您可以通过畅由生活平台为其他人订购商品及/或服务，您需要提供该实际收货人的前述个人信息，并确保已取得该实际收货人的同意。<br />

    为便于您了解、查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。<br />

    您可额外填写/选择包括其他联系电话、收货时间在内的更多附加信息以确保商品或服务的准确送达。<br />

    您可以通过“畅由订单”查看和管理您的订单信息。<br />

    （五）帮助您完成支付<br />
    为完成订单支付，您需要选择付款方式。我们会将您的包括银行卡号、有效期在内的银行卡支付必要信息与您选择的相应金融机构共享。<br />

    为使我们及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务，您同意我们可自您所选择的交易对象或您选择的其他金融机构处收集与支付进度相关信息。<br />

    （六）帮助向您完成商品或服务的交付<br />
    为保证您购买的商品及/或服务能够顺利、安全、准确送达、提供，我们会向为畅由生活平台提供物流信息系统和订单相关的配送信息，并由其根据商品及/或服务提供主体的选择向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。<br />

    为向您提供售后与争议解决服务之目的，我们需要及时获悉并确认交付进度及状态，您同意我们可自物流相关服务主体处收集与交付进度相关的信息。<br />

    （七）客服及争议处理<br />
    当您与我们联系或提出售中、售后、争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的会员身份。<br />

    为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信/通话记录及相关内容（包括账户信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账户信息和订单信息。<br />

    为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。<br />

    （八）为您提供安全保障<br />
    为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或畅由生活平台相关协议、规则的情况，我们在应用程序中嵌入我们关联公司开发的应用安全SDK收集您的设备信息、服务日志信息、运行中的进程信息，并可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。<br />

    （九）为您提供的其他附加服务<br />
    为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影响您使用畅由生活平台的浏览、搜索、购买等基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：<br />

    1、基于位置信息的推荐服务：我们会在您开启位置权限后访问获取您的位置信息，根据您的位置信息为您提供更契合您需求的页面展示、产品及/或服务，比如向您推荐附近的优惠门店、加油站等信息。<br />

    2、基于相机/摄像头的附加服务：您可在开启相机/摄像头权限后使用该功能进行扫码用于登录、购物、领取优惠信息。请您知晓，即使您已同意开启相机/摄像头权限，我们也仅会在您主动拍摄、录制、扫码等使用相机/摄像头时获取信息。<br />

    3、基于相册（图片库/视频库）的图片/视频访问及上传的附加服务：您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像或与客服沟通提供证明等功能。
    我们可能会通过您所上传的照片/图片来识别您需要购买的商品或服务；或使用包含您所上传照片、图片的评论信息。为实现您的好友、活动优惠等链接分享需求，我们可能会在设备本地读取您最近一次主动保存的图片链接地址。<br />

    4、基于通讯录信息的附加服务：我们将在您开启通讯录权限后收集您的通讯录信息，使您在购物时可以更便利地取用您通讯录内的联系人信息，无需再手动输入，包括您可以直接为通讯录中的联系人手机号进行充值。<br />

    5、基于存储权限的附加服务：我们向您申请获取此权限，目的是为了保障客户端的稳定运行。在您开启我们可读取/写入您设备存储的权限后，我们将自您设备存储空间内读取或向其中写入图片、文件、崩溃日志信息等必要信息，用于向您提供信息发布或在本地记录崩溃日志信息等功能。<br />

    6、基于电话状态的附加服务：
    我们读取用户设备信息，判断账号与设备的关联关系，通过技术与风控规则提高登录与账号安全性,我们会读取您的设备识别码或者广告标识符。如果您拒绝授权，您将无法体验上述服务，但不影响您的继续使用畅由APP。<br />

    7、基于发送短信的附加服务： 我们在高德打车业务模块中如遇紧急情况使用短信报警。<br />

    您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息
    （地理位置）、摄像头（相机）、相册（图片库）、通讯录、存储及/或电话状态的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或我们客户端中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。
    请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。<br />

    （十）收集和使用个人信息的其他规则<br />
    1、若您提供的信息中含有其他用户的个人信息，在向畅由生活平台提供这些个人信息之前，您需确保您已经取得合法的授权。<br />

    2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，均会事先获得您的同意。<br />

    3、若我们从第三方处间接获取您的信息，我们会在收集前明确以书面形式要求该第三方说明其个人信息来源，以及是否已经就其收集、处理以及向我们提供您的个人信息取得了您的合法授权。除法律明确允许的情形外，我们只会在确认第三方已经取得您的授权同意后再从第三方收集您的个人信息，如果第三方的授权范围无法涵盖我们的处理和使用目的时，我们会自行或者要求该第三方征得您的同意后再行处理您的个人信息。同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。<br />

    4、请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的个人信息。<br />

    （十一）在以下情形中我们使用您的信息时无需征得您的授权同意：<br />
    1.关系国家安全、国防安全的情况时。<br />
    2.关系公共安全、公共卫生、重大公共利益的情况时。<br />
    3.关系犯罪侦查、起诉、审判和判决执行的情况时。<br />
    4.出于维护个人信息主体或其他个人的生命、财产安全，但又很难得到本人同意的情况下。<br />
    5.所收集的个人信息是个人信息主体自行向社会公众公开的信息。<br />
    6.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道。<br />
    7.根据您的要求签订合同所必需的。<br />
    8.用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障。<br />
    9.为合法的新闻报道所必需的。<br />
    10.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。<br />
    11.法律法规规定的其他情形。<br />
    请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善畅由生活平台的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。<br />

    如我们停止运营畅由生活平台产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。<br />

    二、我们如何使用 Cookie 和同类技术<br />
    （一）为确保客户端正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie
    通常包含标识符、站点名称以及一些号码和字符。通过
    Cookie，客户端能够存储您的选项或购物数据，便于您在不同页面间跳转时仍能记住您的选项或购物篮数据，避免重复输入。<br />
    （二）除 Cookie
    外，我们还会在网站上使用网站信标、像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好，以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。<br />
    （三）SDK的使用，为保障我们客户端的稳定运行、功能实现，使您能够享受和使用更多的服务及功能，我们的应用中会嵌入第三方授权合作伙伴的SDK或其他类似的应用程序。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。在您使用的产品或服务由第三方提供时，我们会向您明确标识和说明。如第三方因服务所必需要采集您的信息，将会单独获得您的授权同意。<br />
    请您注意，您的交易相对方、您访问的第三方网站经营者、通过我们接入的第三方服务接收您的个人信息的第三方可能有自己的隐私权保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或像素标签不受我们的控制，且它们的使用不受本政策的约束。我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，请您与他们直接联系以获得关于他们的隐私权政策的详细情况。如您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。<br />

    第三方SDK具体包括：<br />
    <table border="" width="100%" class="table">
      <tbody>
        <tr>
          <th>SDK<br />名称</th>
          <th width="20%">SDK厂商</th>
          <th>业务场景</th>
          <th>所需权限</th>
        </tr>
        <tr>
          <td>一键登录<br />SDK</td>
          <td>北京一砂信息技术有限公司</td>
          <td>登录</td>
          <td>网络信息，向扩展卡写入数据，用于本地信息缓存</td>
        </tr>
        <tr>
          <td>银联支付<br />SDK</td>
          <td>中国银联股份有限公司</td>
          <td>支付</td>
          <td>常用设备信息（如IMSI），网络信息及地理位置信息</td>
        </tr>
        <tr>
          <td>支付宝<br />SDK</td>
          <td>支付宝(中国)网络技术有限公司</td>
          <td>登录、支付</td>
          <td>
            常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息以及地理位置信息，用于用户登录账户和支付过程中的安全风控
          </td>
        </tr>
        <tr>
          <td>微信<br />SDK</td>
          <td>深圳市腾讯计算机系统有限公司</td>
          <td>微信登录、支付</td>
          <td>
            常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息以及地理位置信息，用于用户登录账户和支付过程中的安全风控
          </td>
        </tr>
        <tr>
          <td>穿山甲广告<br />SDK</td>
          <td>今日头条（厦门）科技有限公司</td>
          <td>开屏广告</td>
          <td>
            必备信息：设备基础信息、应用版本信息以及网络信息。<br />可选信息：位置信息、设备唯一标识符
          </td>
        </tr>

        <tr>
          <td>分享MOb<br />SDK</td>
          <td>上海游昆信息技术有限公司</td>
          <td>社交分享、第三方登录</td>
          <td>
            系统运营信息、网络状态信息、iOS广告标识符（IDFA）、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）、应用列表信息、基站信息、社交平台OpenID、地理位置
          </td>
        </tr>

        <tr>
          <td>Bugly<br />SDK</td>
          <td>腾讯科技(深圳)有限公司</td>
          <td>应用崩溃数据采集</td>
          <td>设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM 卡 IMSI 信息等）</td>
        </tr>

        <tr>
          <td>银联身份证人像比对<br />SDK</td>
          <td>银联商务股份有限公司</td>
          <td>在线实名认证人脸识别</td>
          <td>相机权限、存储权限、用户姓名、用户身份证件号码、面部识别特征信息</td>
        </tr>
      </tbody>
    </table>

    我们不会将 Cookie和同类技术用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
    Cookie。<br />

    三、我们如何共享、转让、公开披露您的个人信息<br />
    （一）共享<br />

    我们不会与畅由生活以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：<br />
    1. 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<br />
    2.
    在法定情形下的共享：我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。<br />
    3.
    与关联公司间共享：与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。我们的关联公司包括畅由现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的合法继承人。其中“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。<br />
    4.授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您通过我们的客户端购买商品或订购业务时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。<br />
    目前，我们的授权合作伙伴包括以下三大类型：<br />
    1.供应商、服务提供商和其他合作伙伴。我们将您的订单信息与交易有关的必要信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴。<br />
    2.第三方商家。我们必须将您的订单信息中与交易有关的必要信息与第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的服务。<br />
    对我们与之共享个人信息的公司、组织和个人，我们会与其签署相应的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。<br />
    （二）转让<br />

    除以下情况外，我们不会将您的个人信息转让给任何公司、组织和个人。<br />
    1.获得您的明确授权后，我们会向您授权的第三方转让您的个人信息。<br />
    2.根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；<br />
    3.符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br />
    4.在本客户端合并、收购或破产清算时，如涉及到个人信息转让时，我们会要求新的公司继续按本隐私政策接收、管理、使用和转让您的信息。若无法达成共识，我们会要求新的公司重新向您征求授权。<br />
    （三）公开披露<br />

    我们仅会在以下情况下，公开披露您的个人信息：<br />
    1．获得您明确同意后，按您授权情况披露您的个人信息。<br />
    2.
    如果我们确定您出现违反法律法规或严重违反畅由生活平台相关协议及规则的情况，或为保护畅由生活平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息。<br />
    (四)、共享、转让、公开披露个人信息时事先征得授权同意的例外<br />

    根据相关法律法规规定，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：<br />
    1、与我们履行法律法规规定的义务相关的；<br />
    2、与国家安全、国防安全直接相关的；<br />
    3、与公共安全、公共卫生、重大公共利益直接想关的；<br />
    4、与犯罪侦查、起诉、审判和判决执行等司法或行政执法直接相关的；<br />
    5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
    6、您自行向社会公众公开的个人信息；<br />
    7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br />
    请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。<br />

    四、我们如何保护和保存您的个人信息<br />
    （一）我们如何保护您的个人信息<br />

    1、我们采取的数据保护技术措施<br />

    我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性，在您的浏览器与服务器之间交换数据时受
    SSL协议加密保护，我们同时对畅由生活网站提供HTTPS协议安全浏览方式；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。目前，我们的重要信息系统已经通过网络安全等级保护的三级以上测评。<br />

    2、我们采取的数据保护管理组织措施<br />

    我们建立了行业内先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升个人信息的安全性。我们已经设置了个人信息保护专职部门，并指定了专人负责儿童个人信息保护。我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容。<br />

    3、个人信息安全事件的响应<br />

    如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理救济措施，以尽可能降低对您个人信息和其他权益的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。<br />

    4、账户安全风险的自主防范<br />

    我们强烈建议您在使用畅由生活平台服务时不要使用非畅由生活平台推荐的通信方式发送您的信息，同时请您使用复杂密码，协助我们保护您的账户安全。<br />

    使用畅由生活平台进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。此外，您也可以通过我们的服务与第三方建立沟通、交流信息或分析内容。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络客服以便我们根据您的申请采取相应措施。<br />

    请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。<br />

    （二）我们如何保存您的个人信息<br />

    1、保存地点<br />

    我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行了法律规定的义务后，向境外实体提供您的个人信息：<br />

    （1）适用的法律有明确规定；<br />
    （2）获得您的明确授权；<br />
    （3）您通过互联网进行跨境交易等个人主动行为。<br />
    针对以上情形，我们会通过合同等形式确保以不低于本政策规定的程度保护您的个人信息。<br />
    2、存储期限<br />

    我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：<br />

    （1）完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；<br />
    （2）保证我们为您提供服务的安全和质量；<br />
    （3）您是否同意更长的留存期间；<br />
    （4）是否存在关于保留期限的其他特别约定或法律法规规定。<br />
    在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。<br />
    3、请您注意，当您成功申请注销账户后，我们将在您提出申请的15个工作日内完成对您的账户注销审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。<br />
    4、如果我们终止服务或运营，我们会至少提前15个工作日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。<br />
    （三）我们如何注销您的账户<br />

    您可以通过以下方式申请注销您的账户：<br />

    1、登录畅由生活平台，通过“我的-设置-关于畅由-注销”提交账户注销申请；<br />
    2、登录畅由生活并选择联系客服，寻求帮助，协助您申请注销您的账户。<br />
    在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。<br />
    注：法律法规有规定不能删除时或不能匿名化处理的情况除外。<br />
    五、您的权利<br />
    （一）查询和更正您的个人信息<br />

    除法律法规规定外，您有权查询、更正或补充您的个人信息。您可以通过以下方式自行进行：<br />

    1、登录畅由生活平台，进入“我的”首页，点击个人账户设置后查询、更正个人资料及个人账户相关信息；<br />
    2、登录畅由生活平台并选择联系客服，协助您查询、更正或补充您的信息。<br />
    （二）删除您的个人信息<br />

    在以下情形中，您可以向我们提出删除个人信息的请求：<br />
    1.如果我们处理个人信息的行为违反了相关法律法规。<br />
    2.如果我们收集、使用您的个人信息，却未征得您的同意。<br />
    3.如果我们处理个人信息的行为违反了与您的约定。<br />
    4.如果您不再使用我们的产品或服务，或您注销了账号。<br />
    5.如果我们不再为您提供产品或服务。<br />
    您可以与我们联系提出您想要删除个人信息的请求。<br />
    当您从我们的客户端中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时及时删除这些信息。<br />
    （三）注销您的账户<br />

    您可以通过以下方式申请注销您的账户：<br />
    1、登录畅由生活平台，通过“我的-设置-关于畅由-注销”提交账户注销申请；<br />
    2、登录畅由生活并选择联系客服，寻求帮助，协助您申请注销您的账户<br />
    在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。<br />
    （四）改变您授权同意的范围<br />

    您可以改变或者收回您授权我们收集和处理您的个人信息的范围：如您是安卓系统用户，您可以在“手机系统设置-应用管理”中设置或改变您的智能移动设备的设置等方式给予、修改或收回您的授权同意；如您是iOS
    系统用户，您可以在“手机系统设置-畅由生活”中设置或改变您的智能移动设备的设置等方式给予、修改或收回您的授权同意。对于您无法直接通过上述方式设置的授权，您可以通过与畅由生活平台客服联系进行修改，但请注意，对于部分类型的个人信息，例如实现畅由生活平台基本功能所必须的信息或者我们履行法律法规规定的义务所必需的信息，我们可能没有办法响应您改变授权范围的请求，响应您的上述请求）。<br />

    当您收回授权后，我们将不再处理相应的个人信息。但您收回授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。<br />

    （五）响应您的上述请求<br />

    为保障您的账户安全，您向我们提出上述请求时，我们可能会先要求您验证您的身份（如要求您提供书面请求或其他方式），然后再处理您的请求<br />

    对于您向我们提出的上述请求，我们将在15天内做出答复。如您不满意我们的答复，还可以通过畅由生活平台客服发起投诉。<br />

    对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。<br />

    在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br />

    1、与我们履行法律法规规定的义务相关的；<br />
    2、与国家安全、国防安全直接相关的；<br />
    3、与公共安全、公共卫生、重大公共利益直接相关的；<br />
    4、与刑事犯罪侦查、起诉、审判和执行判决等直接相关的；<br />
    5、有充分证据表明个人信息主体存在主观恶意或滥用权利的；<br />
    6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；<br />
    7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；<br />
    8、涉及商业秘密的。<br />
    六、关于儿童个人隐私政策的特别约定<br />
    根据《中华人民共和国未成年人保护法》、《儿童个人信息网络保护规定》等相关法律法规，<br />

    1、若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。我们根据国家相关法律法规的规定保护未成年人的个人信息。<br />
    2、我们不会主动直接向未成年人收集其个人信息。对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。<br />
    3、如果有事实证明未成年人并未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。<br />
    七、本政策如何更新<br />
    1、我们与您达成的其他关于个人信息和隐私的条款视为对本政策的补充，本政策存在未涉及内容的，适用其他条款的约定。若因新增产品、服务、功能且需收集、使用、提供您的个人信息的，我们将另行获取您的同意。<br />
    2、发生下列重大变化情形并可能导致您在本政策项下权利的实质减损或产生重大影响时，我们会适时对本政策进行更新：<br />
    （1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变更；<br />

    （2）收集、存储、使用个人信息的范围、目的、规则发生变化；<br />

    （3）对外提供个人信息的对象、范围、目的发生变化；<br />

    （4）您访问和管理个人信息的方式发生变化；<br />

    （5）数据安全能力、信息安全风险发生变化；<br />

    （6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；<br />

    （7）其他可能对您的个人信息权益产生重大影响的变化。<br />

    如本政策发生更新，我们将以畅由生活平台推送通知、发送邮件的方式来通知您。为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您不同意本政策变更，请立即停止访问和使用畅由生活平台。如您在本政策更新生效后继续使用畅由生活平台服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。如本政策任何内容被裁定为无效或不可执行，该内容可被删除，但其余条款或同一条款的其他部分仍有效并应予以执行。<br />
    您可以在畅由生活平台中查看本政策。我们鼓励您在每次使用畅由生活时都查阅我们的隐私政策。<br />
    八、如何联系我们<br />
    1、如果您对本隐私政策有任何疑问、意见、建议或需要投诉，可与我们联系，我们会积极进行查证、处理并尽快答复，可随时拨打客服热线4001536868或通过在线客服联系反馈，一般情况下客服人员将于15个工作日内回复您。<br />

    2、我们成立专门的个人信息保护小组，如有个人信息保护的相关问题，您可以拨打个人信息保护小组热线4001536868。<br />

    九、其他<br />
    服务监督热线电话：400-150-6868（工作日9:00-18:00）<br />
    邮箱地址：cc@centchain.com （受理书面申请核查）<br />
    您还可以通过我们官网、畅由生活平台等自助渠道反馈您的意见，一般情况下客服人员将于15个工作日内响应您的诉求。当您因为本隐私权政策的实施与我们产生任何纠纷时，双方应首先协商友好解决；若不能协商解决，双方有权向我们所在地上海市浦东新区有管辖权的法院提起诉讼。
  </div>
</template>

<script>
export default {
  name: 'cyPrivacyView',
  components: {},
  data() {
    return {}
  },
  created() {},
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content {
  padding: 10px;
}
</style>
